export const WA_NUMBER = '573128348779';
export const WA_MSG = encodeURIComponent(
  'Hola, me contacto desde la página web. Quisiera información sobre los servicios de Mantenimiento M&RG.'
);
export const WA_URL = `https://wa.me/${WA_NUMBER}?text=${WA_MSG}`;

export const PAGES = ['inicio', 'servicios', 'productos', 'contacto'];

export const SERVICES = [
  {
    icon: '🔧',
    name: 'Mantenimiento y Reparación de Dispensadores',
    desc: 'Mantenimiento preventivo y correctivo de equipos dispensadores y surtidores de combustible.',
  },
  {
    icon: '⚙️',
    name: 'Calibración de Surtidores',
    desc: 'Calibración precisa para dispensadores y surtidores, garantizando exactitud en el despacho.',
  },
  {
    icon: '🛢️',
    name: 'Tanques Subterráneos y Elevados',
    desc: 'Mantenimiento, limpieza, desgasificado y pruebas hidrostáticas. Control del nivel de gases.',
  },
  {
    icon: '🔩',
    name: 'Bombas Sumergibles',
    desc: 'Instalación, montaje, mantenimiento y reparación de bombas sumergibles para tanques.',
  },
  {
    icon: '🏗️',
    name: 'Cajas Contenedoras y Spill Container',
    desc: 'Instalación de cajas contenedoras, detección y corrección de fugas y filtraciones.',
  },
  {
    icon: '⚡',
    name: 'Instalaciones Eléctricas',
    desc: 'Revisiones y reparaciones eléctricas. Diseño y montaje de gabinetes de controles eléctricos.',
  },
  {
    icon: '📡',
    name: 'Avisos Digitales y Señalización',
    desc: 'Mantenimiento, reparación y montaje de avisos digitales para estaciones de servicio.',
  },
  {
    icon: '🔴',
    name: 'Válvulas de Seguridad',
    desc: 'Instalación de válvulas de impacto y seguridad para equipos dispensadores y surtidores.',
  },
  {
    icon: '🏗️',
    name: 'Reparación de Infraestructura',
    desc: 'Reparación de perimetrales y pisos para estaciones de servicios. Obras civiles menores.',
  },
  {
    icon: '🔵',
    name: 'Recubrimiento con Fibra de Vidrio',
    desc: 'Recubrimiento anticorrosivo de tanques con fibra de vidrio para protección duradera.',
  },
  {
    icon: '🔍',
    name: 'Chequeo de Líneas de Presión',
    desc: 'Diagnóstico y verificación de líneas de presión y sistemas hidráulicos.',
  },
  {
    icon: '🧰',
    name: 'Equipos de Lubricación',
    desc: 'Mantenimiento preventivo y correctivo para equipos de lubricación y sistemas de aceite.',
  },
  {
    icon: '🪣',
    name: 'Trampas de Grasa',
    desc: 'Limpieza y mantenimiento a trampas de grasa conforme a normativas ambientales.',
  },
];

export const PRODUCTS_MAIN = [
  { name: 'Bombas sumergibles', cat: 'Equipos principales' },
  { name: 'Válvulas de impacto', cat: 'Seguridad' },
  { name: 'Flexos hidráulicos', cat: 'Conexiones' },
  { name: 'Tubos retráctiles para bombas sumergibles', cat: 'Accesorios' },
  { name: 'Motores para bombas sumergibles', cat: 'Repuestos' },
  { name: 'Repuestos para dispensadores', cat: 'Repuestos' },
  { name: 'Unidades de medida (Gilbarco, Wayne, Tokheim, Hong Yang)', cat: 'Metrología' },
  { name: 'Equipos remanufacturados', cat: 'Equipos' },
  { name: 'Equipos nuevos', cat: 'Equipos' },
  { name: 'Manguera 3/4" y 1"', cat: 'Conexiones' },
];

export const PRODUCTS_OTHER = [
  'Contadores Licuid Controls',
  'Contadores Fill-Rite',
  'Acoples reutilizables manguera 3/4"',
  'Acoples reutilizables manguera 1"',
  'Contadores electrónicos pistolas de aceite',
  'Pistolas de grasa',
  'Filtros interiores y exteriores con base',
  'Targetas electrónicas para dispensadores',
];

export const WHY_ITEMS = [
  {
    title: 'Experiencia Especializada',
    desc: 'Años de trabajo exclusivo en estaciones de servicio y la industria del petróleo en Colombia.',
  },
  {
    title: 'Cobertura Integral',
    desc: 'Desde mantenimiento preventivo hasta instalaciones completas y atención de emergencias.',
  },
  {
    title: 'Altos Estándares de Calidad',
    desc: 'Cumplimiento de normativas del sector. Técnicos certificados y equipados.',
  },
  {
    title: 'Productos y Servicio Propio',
    desc: 'Comercializamos repuestos y equipos directamente, reduciendo tiempos y costos.',
  },
];
